module.exports = __webpack_public_path__ + "static/img/30005 (4).54fd2b0.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30005 (4).webp
// module id = I3b4
// module chunks = 14